module.exports = {"pathContext":{"name":"DosageInputType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CALCULATED_AMOUNT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DOSE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TOTAL_DOSE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-dosage-input-type.json
// module id = 1235
// module chunks = 133636646567993